<div class="flex flex-middle">
    <price [precision]='2'
           class="block col-12 line-through price m-r-1"
           [class.o1]="(client.isS || client.isM) && variant === 'pdp'"
           [attr.sl-minibasket-item-orgprice]="product.id"
           [value]="product.orgPrice"
           *ngIf="newPrice"></price>
    <price [precision]='2'
           class="block price"
           [class.o1]="(client.isS || client.isM) && variant === 'pdp'"
           [attr.sl-minibasket-item-price]="product.id"
           [value]="newPrice || product.price"></price>
    <span *ngIf="!newPrice && variant === 'pdp'"
          class="p2 col-11 m-l-2">{{'standard trade price' | translate}}</span>
</div>